import { render } from "./index.vue?vue&type=template&id=2469e06a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2469e06a&scoped=true&lang=less"

import exportComponent from "/Users/xiaobiaoza/Desktop/workspace/GIM/WPP/wpp-aigc-aigc-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2469e06a"],['__file',"src/layouts/basic-layout/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2469e06a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2469e06a', __exports__)) {
    console.log('reload')
    api.reload('2469e06a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2469e06a&scoped=true", () => {
    console.log('re-render')
    api.rerender('2469e06a', render)
  })

}


export default __exports__